export default "__VITE_ASSET__C8qlQJtl__"